import { UseFetchReturn } from '@vueuse/core';
import { useFetchInstance } from './useFetchInstance';
import { SiteApi } from '@/types/Site';

export function useSite() {
    async function getSiteInfos(): Promise<UseFetchReturn<SiteApi>> {
        return await useFetchInstance('/sites/current').get().json();
    }

    async function getSiteConfig(configurationUrl: string): Promise<UseFetchReturn<{}>> {
        return await useFetchInstance(`/downloadFile?filename=${configurationUrl}`).get().json();
    }

    return {
        getSiteInfos,
        getSiteConfig
    };
}
